/*
 * 最近チェックしたタレント（タレント訪問履歴）のデータ層。
 * localStorage 'recentlyViewedTalent' の記録（write）と読み出し（read）だけを担い、DOM 描画はしない。
 * 描画（表示層）は quicklook-search.js が load() の結果を使って行う。
 * 記録元は theme が各コレクションページに出力する #QuicklookTalentVisit（表示データ JSON）。
 * localStorage 保存は配列操作のみで行う（商品履歴 setRecentlyViewedProducts の inline 実装は踏襲しない）。
 */
(function () {
  const TALENT_KEY = 'recentlyViewedTalent';
  const TALENT_MAX = 8;

  /** localStorage からタレント履歴配列を読む。未保存/壊れていれば []。 */
  function load() {
    try {
      const data = JSON.parse(localStorage.getItem(TALENT_KEY));
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  /**
   * タレント履歴へ 1 訪問を反映した新配列を返す（純粋関数）。同一 handle を除いてから先頭へ追加し、
   * 上限 TALENT_MAX 件で切る（新しい順・重複は先頭へ繰り上げ）。
   */
  function applyVisit(list, entry) {
    const deduped = list.filter((item) => item.handle !== entry.handle);
    return [entry, ...deduped].slice(0, TALENT_MAX);
  }

  /**
   * theme が出力した #QuicklookTalentVisit（タレントのコレクションページのみ存在）を読み、履歴を更新する。
   * JSON が無ければ何もしない（＝タレントページ以外）。保存不可（プライベートモード等）はサイレントに握る。
   */
  function record() {
    const el = document.getElementById('QuicklookTalentVisit');
    if (!el) return;
    let entry;
    try {
      entry = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    if (!entry || !entry.handle) return;
    try {
      localStorage.setItem(TALENT_KEY, JSON.stringify(applyVisit(load(), entry)));
    } catch (e) {
      // 保存不可（ストレージ無効/容量超過）でも遷移・描画は継続する。
    }
  }

  // 表示層（quicklook-search.js）へ read を公開する。書き込みはこのモジュールが訪問時に自己完結で行う。
  window.quicklookRecentTalents = { load: load };

  // タレント訪問の記録は表示層と独立した副作用。defer 実行時点で body はパース済みのため即実行でよい。
  record();
})();
